import { render } from "./LookUpSearchTable.vue?vue&type=template&id=0a2fe363&ts=true"
import script from "./LookUpSearchTable.vue?vue&type=script&lang=ts"
export * from "./LookUpSearchTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/crud/infrastructure/search/LookUpSearchTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a2fe363"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a2fe363', __exports__)) {
    api.reload('0a2fe363', __exports__)
  }
  
  module.hot.accept("./LookUpSearchTable.vue?vue&type=template&id=0a2fe363&ts=true", () => {
    api.rerender('0a2fe363', render)
  })

}


export default __exports__